module.exports = __webpack_public_path__ + "static/img/new-user-invite-code-1.16c2c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/new-user-invite-code-1.png
// module id = uq0j
// module chunks = 216